import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, MessageSquare, FileText, Menu, Sparkles } from 'lucide-react';

const ITEMS = {
  mieter: [
    { label: 'Start', path: '/portal/mieter-portal', icon: Home },
    { label: 'Vorgänge', path: '/portal/vorgaenge', icon: MessageSquare },
    { label: 'Dokumente', path: '/portal/dokumente', icon: FileText },
  ],
  eigentuemer: [
    { label: 'Start', path: '/portal/dashboard', icon: Home },
    { label: 'Vorgänge', path: '/portal/vorgaenge', icon: MessageSquare },
    { label: 'Dokumente', path: '/portal/dokumente', icon: FileText },
  ],
};

export const MobileBottomNav = ({ role, onMenu }) => {
  const { pathname } = useLocation();
  const items = ITEMS[role];
  if (!items) return null;
  const isActive = (p) => pathname === p || pathname.startsWith(`${p}/`);
  const base = 'flex flex-col items-center justify-center gap-0.5 flex-1 min-w-0 py-2 text-[10px] font-medium transition-colors';
  return (
    <nav data-testid="mobile-bottom-nav" aria-label="Schnellnavigation"
      className="lg:hidden fixed bottom-0 inset-x-0 z-[99980] bg-white/95 backdrop-blur border-t border-gray-200 shadow-[0_-4px_16px_rgba(30,58,95,0.08)] pb-[env(safe-area-inset-bottom)]">
      <div className="flex items-stretch">
        {items.map(it => {
          const active = isActive(it.path);
          return (
            <Link key={it.path} to={it.path} data-testid={`bottom-nav-${it.label.toLowerCase()}`}
              className={`${base} ${active ? 'text-brand-navy' : 'text-gray-400 hover:text-brand-navy'}`}>
              <span className={`w-9 h-7 rounded-full flex items-center justify-center transition-colors ${active ? 'bg-brand-navy/10' : ''}`}>
                <it.icon className="w-5 h-5" />
              </span>
              {it.label}
            </Link>
          );
        })}
        <Link to="/portal/ai-assistent" data-testid="bottom-nav-sonja"
          className={`${base} ${isActive('/portal/ai-assistent') ? 'text-brand-navy' : 'text-gray-400 hover:text-brand-navy'}`}>
          <span className="w-9 h-7 rounded-full flex items-center justify-center bg-brand-gold text-brand-navy shadow-sm">
            <Sparkles className="w-4.5 h-4.5" />
          </span>
          Kontakt
        </Link>
        <button type="button" onClick={onMenu} data-testid="bottom-nav-menu" className={`${base} text-gray-400 hover:text-brand-navy`}>
          <span className="w-9 h-7 rounded-full flex items-center justify-center"><Menu className="w-5 h-5" /></span>
          Menü
        </button>
      </div>
    </nav>
  );
};

export default MobileBottomNav;
